import { useState, useEffect } from 'react';
import { featuresItems } from '@/mocks/home';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '关于我们', href: '#about' },
  { label: '精选专题', href: '#cards' },
  { label: '热门话题', href: '#topics' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between h-[72px] px-4 md:px-6">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap">
          <span className="font-heading text-2xl font-bold text-foreground-950">
            爱漫画网
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#updates"
            className="px-5 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-4 flex flex-col gap-2">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#updates"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-5 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md text-center transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </a>
        </div>
      )}
    </header>
  );
}